import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiHolder, apis, NotificationReadFlag, } from 'api';
import { batchDeleteNoticeList, batchMarkReadNoticeList } from '@web-common/utils/utils';
const notificationCenterApi = apiHolder.api.requireLogicalApi(apis.notificationCenterApiImpl);
const initialState = {
    noticeNum: { totalNum: 0, unreadNum: 0 },
    quickNoticeList: { all: [], unread: [] },
    pageNoticeList: { total: 0, list: [] },
    refreshPage: 0,
    refreshLiveMessage: 0,
};
export const doFetchNoticeNum = createAsyncThunk('noticeCenter/fetchNoticeNum', () => {
    return notificationCenterApi.getNotificationQuickListCount();
});
export const doFetchNoticeQuickList = createAsyncThunk('noticeCenter/doFetchNoticeQuickList', (params) => {
    return notificationCenterApi.getNotificationQuickList(params);
});
export const doBatchDeleteNotice = createAsyncThunk('noticeCenter/doBatchDeleteNotice', (ids) => {
    return notificationCenterApi.batchUpdateNotificationDelete(ids).then(() => ({ ids }));
});
export const doBatchMarkReadNotice = createAsyncThunk('noticeCenter/doBatchMarkReadNotice', (ids) => {
    return notificationCenterApi.batchUpdateNotificationRead(ids).then(() => ({ ids }));
});
export const doMarkAllReadNotice = createAsyncThunk('noticeCenter/doMarkAllReadNotice', () => {
    return notificationCenterApi.updateNotificationAllRead();
});
const noticeCenterSlice = createSlice({
    name: 'noticeCenter',
    initialState,
    reducers: {
        updateNoticeNum(state, action) {
            const { payload } = action;
            state.noticeNum = {
                totalNum: payload.totalNum !== undefined ? payload.totalNum : state.noticeNum.totalNum,
                unreadNum: payload.unreadNum !== undefined ? payload.unreadNum : state.noticeNum.unreadNum,
            };
        },
        refreshPage(state) {
            state.refreshPage += 1;
            if (state.refreshPage > 10000) {
                state.refreshPage = 1;
            }
        },
        refreshLiveMessage(state) {
            state.refreshLiveMessage += 1;
            if (state.refreshLiveMessage > 10000) {
                state.refreshLiveMessage = 1;
            }
        },
    },
    extraReducers: builder => {
        builder.addCase(doFetchNoticeNum.fulfilled, (state, action) => {
            noticeCenterSlice.caseReducers.updateNoticeNum(state, action);
        });
        builder.addCase(doFetchNoticeQuickList.pending, (state, action) => {
            const { meta } = action;
            const { readFlag } = meta.arg || {};
            if (readFlag === undefined) {
                state.quickNoticeList.all = [];
            }
            else if (readFlag === NotificationReadFlag.UNREAD) {
                state.quickNoticeList.unread = [];
            }
        });
        builder.addCase(doFetchNoticeQuickList.fulfilled, (state, action) => {
            const { payload, meta } = action;
            const { readFlag } = meta.arg || {};
            if (readFlag === undefined) {
                state.quickNoticeList.all = payload.groups;
            }
            else if (readFlag === NotificationReadFlag.UNREAD) {
                state.quickNoticeList.unread = payload.groups;
            }
        });
        builder.addCase(doBatchDeleteNotice.fulfilled, (state, action) => {
            const { payload } = action;
            state.quickNoticeList.all = batchDeleteNoticeList(state.quickNoticeList.all, payload.ids);
            state.quickNoticeList.unread = batchDeleteNoticeList(state.quickNoticeList.unread, payload.ids);
        });
        builder.addCase(doBatchMarkReadNotice.fulfilled, (state, action) => {
            const { payload } = action;
            state.quickNoticeList.all = batchMarkReadNoticeList(state.quickNoticeList.all, payload.ids);
            state.quickNoticeList.unread = batchMarkReadNoticeList(state.quickNoticeList.unread, payload.ids);
        });
        builder.addCase(doMarkAllReadNotice.fulfilled, state => {
            state.quickNoticeList.all = batchMarkReadNoticeList(state.quickNoticeList.all);
            state.quickNoticeList.unread = batchMarkReadNoticeList(state.quickNoticeList.unread);
        });
    },
});
export const { updateNoticeNum } = noticeCenterSlice.actions;
export const { actions } = noticeCenterSlice;
export default noticeCenterSlice.reducer;
